// src/elements/DescriptionList/DescriptionList.Title.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var Title = _ref => {
  let {
    children,
    className
  } = _ref;
  return /* @__PURE__ */jsx("dt", {
    className: clsx("pd-descriptionlist__title", className),
    children
  });
};
var DescriptionList_Title_default = Title;
export { DescriptionList_Title_default };